import chroma from 'chroma-js'

export function getClrGradient({
  clr1,
  clr2,
  xaxis,
}: {
  clr1: chroma.ChromaInput
  clr2: chroma.ChromaInput
  xaxis: number
}) {
  // https://gka.github.io/chroma.js/#chroma-mix
  return chroma.mix(clr1, clr2, xaxis).hex()
}
